import React from "react";

const SourceCard = ({ source: { name , isAlpha, img, link } }) => {
  return (
    <div className="source__card ">
      <div className="source__card-imgcont">
          <img
            className="source__image"
            src={img}
            alt="img"
          />
      </div>
      <div className="source__card-name">{name}</div>
      <a href={link} target="_blank"  rel="noopener noreferrer">
      <div className="source__cta">
        Read docs <img src={require("../../assets/images/arrow-right.svg")} alt="arrow" />
      </div>
      </a>
      {isAlpha && <div className="source__card-alpha">Alpha Version</div> }
    </div>
  );
};

export default SourceCard;
